import "reflect-metadata";
import { Container } from "inversify";
import { ChatMessagesStore } from "./stores/ChatMessagesStore";
import { GroupsTabStore } from "./stores/GroupsTabStore";

const configureContainer = (container: Container): Container => {
  container.bind(ChatMessagesStore).toSelf();
  container.bind(GroupsTabStore).toSelf();
  return container;
};

export const container = configureContainer(
  new Container({
    defaultScope: "Singleton",
  })
);

export const createContainer = (): Container =>
  configureContainer(
    new Container({
      defaultScope: "Singleton",
    })
  );
